import script from "./header-item.vue?vue&type=script&setup=true&lang=js"
export * from "./header-item.vue?vue&type=script&setup=true&lang=js"

import "./header-item.vue?vue&type=style&index=0&id=dec2e9b6&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dec2e9b6"]])

export default __exports__